import { CheckboxProps, RadioGroupProps, RadioProps, TextFieldProps } from '@mui/material';
import { FocusEventHandler, ReactElement } from 'react';
import { FieldInputProps } from 'formik';
import moment, { Moment } from 'moment-timezone';
import { DateView } from '@mui/x-date-pickers';

export type FormikTextFieldProps = {
  formikKey: string;
} & TextFieldProps;

export type FormikInputFieldProps = {
  formikKey: string;
  label?: string;
  readOnly?: boolean;
  noOffset?: boolean;
  placeholder?: string;
  startIcon?: ReactElement;
} & TextFieldProps;

export type FormikRadioFieldProps = {
  label?: string;
  formikKey: string;
} & RadioProps;

export type FormikRadioGroupProps = {
  formikKey: string;
} & RadioGroupProps;

export type FormikRadioButtonProps = {
  className?: string;
  formikKey: string;
  label?: string;
  value?: boolean | string | readonly string[];
};

// Types
export enum TimesOfDay {
  Midnight = 'midnight',
  Noon = 'noon',
  EndOfDay = 'endOfDay',
}
type TimeOfDay = 'midnight' | 'noon' | 'endOfDay';

export interface IFormikDatePickerProps {
  className?: string;
  disabled?: boolean;
  disablePast?: boolean;
  field: FieldInputProps<Moment>;
  format?: string;
  formikKey: string;
  fullWidth?: boolean;
  label?: string;
  maxDate?: Moment;
  minDate?: Moment;
  onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onChange?: (name: string, date: moment.Moment) => void;
  required?: boolean;
  timeOfDay?: TimeOfDay;
  style?: unknown;
  openTo?: DateView;
  placeholder?: string;
  views?: ['year' | 'month' | 'day'];
}

export type FormikCheckboxFieldProps = {
  formikKey: string;
} & CheckboxProps;
